import { transactions, tranTypes, paymentMethods, GSTIO, riTypes, proplXol, grossNet, settCode, prtOffSetLtr, riskCurrency, riskAccumulateBased, riskFilterBy, printDocOpts } from '@/const/common'
export const commonMixins = {
  computed: {
    transactionList() {
      const list = Object.freeze(transactions)
      return Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
    },
    tranTypeList1() {
      const list = Object.freeze(tranTypes)
      return Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
    },
    paymentMethods() {
      const list = Object.freeze(paymentMethods)
      return Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
    },
    gstIOs() {
      const list = Object.freeze(GSTIO)
      return Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
    },
    riTypeList() {
      const list = Object.freeze(riTypes)
      return Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
    },
    proplXolList() {
      const list = Object.freeze(proplXol)
      return Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
    },
    grossNetList() {
      const list = Object.freeze(grossNet)
      return Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
    },
    settCodeList() {
      const list = Object.freeze(settCode)
      return Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
    },
    prtOffSetLtrList() {
      const list = Object.freeze(prtOffSetLtr)
      return Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
    },
    riskCurrencyList() {
      const list = Object.freeze(riskCurrency)
      return Object.keys(list).map(key => {
        return {
          label: list[key],
          value: key
        }
      })
    },
    riskAccumulateBasedList() {
      const list = Object.freeze(riskAccumulateBased)
      return Object.keys(list).map(key => {
        return {
          label: list[key],
          value: key
        }
      })
    },
    riskFilterByList() {
      const list = Object.freeze(riskFilterBy)
      return Object.keys(list).map(key => {
        return {
          label: list[key],
          value: key
        }
      })
    },
    printDocOptsList() {
      const list = Object.freeze(printDocOpts)
      return Object.keys(list).map(key => {
        return {
          label: list[key],
          value: key
        }
      })
    }
  },
  methods: {
    getItemSecondValue(key, arrayList) {
      for (let param of arrayList) {
        if (param.secondaryValue === key) {
          return param
        }
      }
      return {}
    },
    getItemValue(key, arrayList) {
      for (let param of arrayList) {
        if (param.value === key) {
          return param
        }
      }
      return {}
    },
    getItemLabel(key, arrayList) {
      for (let param of arrayList) {
        if (param.label === key) {
          return param
        }
      }
      return {}
    },
    getItemValueList(key, arrayList) {
      for (var i = 0; i < arrayList.length; i++) {
        if (arrayList[i].value !== key) {
          arrayList.splice(i, 1)
          i--
        }
      }
      return arrayList
    },
    getItemValueList2(key, arrayList) { // For Claim Payment gstStatus + Rate
      for (var i = 0; i < arrayList.length; i++) {
        if (arrayList[i].value !== key) {
          arrayList.splice(i, 1)
          i--
        } else if (arrayList[i].value === key) {
          arrayList[i].label = arrayList[i].label + ' - ' + arrayList[i].date + ' - ' + arrayList[i].rate
        }
      }
      return arrayList
    }
  }
}
